import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { Input } from '../components/ui/input';
import api, { enrichBlog } from '../lib/api';

const CATEGORIES = ['All', 'Buying Tips', 'Selling Tips', 'Market Trends', 'Investment', 'Lifestyle'];

export default function Blog() {
  const [cat, setCat] = useState('All');
  const [q, setQ] = useState('');
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const params = {};
    if (cat !== 'All') params.category = cat;
    if (q) params.q = q;
    const t = setTimeout(() => {
      api.get('/blog', { params }).then(r => setPosts((r.data || []).map(enrichBlog)));
    }, 250);
    return () => clearTimeout(t);
  }, [cat, q]);

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div className="bg-white min-h-screen">
      <div className="bg-gradient-to-r from-neutral-900 to-neutral-800 text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <h1 className="text-3xl md:text-4xl font-bold">Real Estate Insights</h1>
          <p className="text-neutral-300 mt-2 max-w-2xl">Tips, trends, and expert advice for buyers, sellers, and investors in the Philippines.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row gap-4 justify-between mb-8">
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((c) => (
              <button key={c} onClick={() => setCat(c)} className={'px-3 py-1.5 text-sm rounded-full border transition-colors ' + (cat === c ? 'bg-[#DC2626] text-white border-[#DC2626]' : 'border-neutral-300 text-neutral-700 hover:border-[#DC2626] hover:text-[#DC2626]')}>{c}</button>
            ))}
          </div>
          <div className="w-full md:w-72">
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles..." />
          </div>
        </div>

        {featured && (
          <Link to={'/blog/' + featured.slug} className="block mb-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-neutral-50 rounded-2xl overflow-hidden card-hover">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={featured.cover} alt={featured.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 flex flex-col justify-center">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#DC2626]">{featured.category}</span>
                <h2 className="mt-2 text-2xl md:text-3xl font-bold text-neutral-900">{featured.title}</h2>
                <p className="mt-3 text-neutral-600">{featured.excerpt}</p>
                <div className="mt-5 flex items-center gap-4 text-xs text-neutral-500">
                  <span className="flex items-center gap-1"><User className="w-3 h-3" /> {featured.author}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {featured.date}</span>
                </div>
                <span className="mt-5 inline-flex items-center gap-1 text-[#DC2626] font-semibold">Read More <ArrowRight className="w-4 h-4" /></span>
              </div>
            </div>
          </Link>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((p) => (
            <Link to={'/blog/' + p.slug} key={p.id} className="block card-hover bg-white border border-neutral-200 rounded-xl overflow-hidden">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#DC2626]">{p.category}</span>
                <h3 className="mt-2 font-bold text-neutral-900 line-clamp-2">{p.title}</h3>
                <p className="mt-2 text-sm text-neutral-600 line-clamp-2">{p.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-neutral-500">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {p.date}</span>
                  <span className="text-[#DC2626] font-semibold">Read →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {posts.length === 0 && <div className="text-center py-12 text-neutral-600">No articles match your filters.</div>}
      </div>
    </div>
  );
}
